import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './layouts/Layout';
import Projects from './pages/Projects';
import Project from './pages/Project';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en-gb';
import Home from './pages/Home';
import Login from './pages/Login';
import FormContextProvider from './contexts/FormContext';
import ProtectedRoute from './components/ProtectedRoute';
import { LoginCallback } from '@okta/okta-react';
import { OktaAuthContextProvider } from './contexts/OktaAuthContext.tsx';

export default function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <BrowserRouter>
        <OktaAuthContextProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/projects" />} />
              <Route path="/home" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route
                path="/project/:id?"
                element={
                  <FormContextProvider>
                    <Project />
                  </FormContextProvider>
                }
              />
            </Route>
            <Route path="*" element={<div>Route not found</div>} />
          </Routes>
        </OktaAuthContextProvider>
      </BrowserRouter>
    </LocalizationProvider>
  );
}
